import {
  getApiV1ThreeLetterCodeClientAdminsBranchesId,
  getGetApiV1ThreeLetterCodeClientAdminsBranchesIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodeClientAdminsBranchesId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
  branchId: number;
};

type IUseGetBranch = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsBranchesId200;
};

/**
 * 事業所詳細取得フック
 */
export const useGetBranch: IUseGetBranch = ({ threeLetterCode, branchId }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodeClientAdminsBranchesIdKey(threeLetterCode, branchId),
    () => getApiV1ThreeLetterCodeClientAdminsBranchesId(threeLetterCode, branchId),
    { suspense: true }
  );

  return { data };
};
